/**
 * 대화 목록 — 사이드바가 "내 대화들"을 그리는 데 쓰는 서버 데이터.
 *
 * 인가는 **백엔드 질의**가 쥔다(`thread_owners` INNER JOIN). 여기서 거르지 않는 이유가 그것이다 —
 * 프런트 필터는 인가가 아니라 표시일 뿐이고, 그렇게 짜두면 나중에 누군가 그 필터를 지운다.
 *
 * 목록에는 **본문이 없다**(제목·시각뿐). 본문은 대화를 열 때 transcript 로 한 번 흐른다.
 */
import { request } from '@/api/client'
import { API } from '@/api/paths'

export interface ThreadSummary {
  thread_id: string
  /** 프런트가 지어 보낸 제목. `null` 은 정상 — 화면이 시각으로 대신 표시한다. */
  title: string | null
  updated_at: string | null
  /** 소속 프로젝트(F-6). `null` 은 어디에도 안 묶인 대화 — 정상 상태다. */
  project_id?: string | null
}

export interface ThreadListResponse {
  threads: ThreadSummary[]
  /** 비어 있는 이유(미인증·DB 미연결). 빈 목록을 고장으로 읽지 않게 화면이 그대로 보여준다. */
  detail?: string
}

export async function fetchThreads(limit = 50): Promise<ThreadListResponse> {
  return await request<ThreadListResponse>(`${API.threads}?limit=${limit}`)
}

/** 목록 표시 이름 — 제목이 없으면 **지어내지 않고** 갱신 시각으로 대신한다. */
export function threadLabel(
  thread: ThreadSummary,
  locale: string,
  fallback: (at: string) => string,
): string {
  if (thread.title) return thread.title
  if (!thread.updated_at) return fallback('—')
  const at = new Date(thread.updated_at)
  return fallback(Number.isNaN(at.getTime()) ? '—' : at.toLocaleDateString(locale))
}
